module.exports = __webpack_public_path__ + "img/tab3s.b1aed5a1.jpg";